// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__27nKK","form":"EditListingDescriptionPanel_form__3S5VC","title":"EditListingDescriptionPanel_title__1qyVa"};